import ReactDOM from "react-dom";

import { TCreateContainerReturns } from "../types";

const createContainer = (): TCreateContainerReturns => {
  if (!document) {
    throw new Error("Cannot call createContainer in a non-browser environment");
  }

  const container = document.createElement("div");
  container.id = "modal-root";
  document.body.appendChild(container);

  const destroy = () => {
    const didUnmount = ReactDOM.unmountComponentAtNode(container);

    if (didUnmount) {
      container.parentNode?.removeChild(container);
    }
  };

  return { container, destroy };
};

export default createContainer;
